"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
var form_field_1 = require("@material/form-field");
var checkbox_1 = require("@material/checkbox");
// @ts-ignore
var util_ts_1 = require("../util.ts");
//@ts-ignore
require("../theme.ts");
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.changeHandler = function (e) {
            _this.fire('change', e.currentTarget.checked);
        };
        return _this;
    }
    Checkbox.prototype.installed = function () {
        var checkbox = new checkbox_1.MDCCheckbox(this.shadowRoot.querySelector('.mdc-checkbox'));
        var formField = new form_field_1.MDCFormField(this.shadowRoot.querySelector('.mdc-form-field'));
        formField.input = checkbox;
    };
    Checkbox.prototype.render = function (props) {
        return (omi_1.h("div", __assign({}, omi_1.extractClass(props, 'mdc-form-field', {
            'mdc-checkbox--disabled': props.disabled
        })),
            omi_1.h("div", { class: "mdc-checkbox" },
                omi_1.h("input", __assign({ type: "checkbox", onChange: this.changeHandler }, util_ts_1.extract(props, ['checked', 'value', 'indeterminate']), { class: "mdc-checkbox__native-control", id: "checkbox" })),
                omi_1.h("div", { class: "mdc-checkbox__background" },
                    omi_1.h("svg", { class: "mdc-checkbox__checkmark", viewBox: "0 0 24 24" },
                        omi_1.h("path", { class: "mdc-checkbox__checkmark-path", fill: "none", d: "M1.73,12.91 8.1,19.28 22.79,4.59" })),
                    omi_1.h("div", { class: "mdc-checkbox__mixedmark" }))),
            omi_1.h("label", { for: "checkbox" }, props.label)));
    };
    Checkbox.css = css;
    Checkbox.propTypes = {
        label: String,
        disabled: Boolean,
        indeterminate: Boolean,
        checked: Boolean,
        value: String
    };
    Checkbox = __decorate([
        omi_1.tag('m-checkbox')
    ], Checkbox);
    return Checkbox;
}(omi_1.WeElement));
exports.default = Checkbox;
